import { api } from './base-api';
import {
  ClienteVendaDetail,
  ClienteVendasFilters,
  PaginatedClienteVendas,
} from '../../types/cliente-venda';

const cleanParams = (filters: Record<string, unknown>) => {
  const result: Record<string, string | number | boolean> = {};
  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null || value === '') continue;
    result[key] = value as string | number | boolean;
  }
  return result;
};

export interface ListClienteVendasParams extends Partial<ClienteVendasFilters> {
  page?: number;
  limit?: number;
}

export const clienteVendasApi = {
  async listByCliente(
    clienteId: string,
    params: ListClienteVendasParams = {},
  ): Promise<PaginatedClienteVendas> {
    const { data } = await api.get<PaginatedClienteVendas>(
      `/admin/clientes/${clienteId}/vendas`,
      { params: cleanParams({ ...(params as Record<string, unknown>) }) },
    );
    return data;
  },

  async detail(vendaId: string): Promise<ClienteVendaDetail> {
    const { data } = await api.get<ClienteVendaDetail>(
      `/admin/vendas/${vendaId}`,
    );
    return data;
  },
};
